import type { OperationSummary } from "../types";
import { OperationList } from "./OperationList";
import { OperationShow } from "./OperationShow";

/**
 * ASSUMPTION (Almikia Epic E4): desktop resource; no create (operations are
 * created by the reservation flow), no edit route (the administrative form
 * lives on the detail page) and no delete (cancelled instead).
 */
export default {
  list: OperationList,
  show: OperationShow,
  recordRepresentation: (record: OperationSummary) => record.id,
};
